import { EventsAPI } from "../../../core/api";

/**
 * Map an event to a select option.
 * @param {Object} event - The event.
 * @returns {Object} The option `{ value, label }`.
 */
export function buildEventOption(event) {
    return { value: event._id, label: `${event.name} (${event.code})` };
}

/**
 * Load the event options. When the selected event is not in the list (ended or inactive),
 * it is fetched by ID and added so the select can still show it.
 * @param {string} token - The authentication token.
 * @param {string|null} [selectedEventId=null] - The event already assigned to the reservation.
 * @returns {Promise<Array<Object>>} The event options.
 */
export async function loadEventOptions(token, selectedEventId = null) {
    let options = [];
    try {
        const { data } = await EventsAPI.getEventOptions(token);
        options = (data || []).map(buildEventOption);
    } catch (error) {
        options = [];
    }
    if (selectedEventId && !options.some(option => option.value === selectedEventId)) {
        try {
            const { data: event } = await EventsAPI.getEventById(selectedEventId, token);
            if (event) options.unshift(buildEventOption(event));
        } catch (error) {
            // A deleted event is not shown; the reservation keeps its value until it is changed.
        }
    }
    return options;
}
